import Api from '@/services/Api'

export default {
  getAll () {
    return Api().get('/invoice')
  },
  create (data) {
    return Api().post('/invoice', data)
  },
  edit (data) {
    return Api().put('/invoice/' + data.id, data)
  },
  delete (data) {
    return Api().delete('/invoice/' + data.id)
  },
  fetchInvoices (data) {
    return Api().get('/company/' + data.id + '/invoices')
  },
  sendOnEmail (data) {
    return Api().post('/invoice/' + data.id + '/send')
  },
  fetchInvoiceById (id) {
    return Api().get('/invoice/' + id)
  }
}
